import styled from 'styled-components';

export type ProgressBarProps = {
  value: number;
  backgroundColor: string;
};

const StyledProgressBar = styled.div<{ $value: number; $backgroundColor: string }>`
  background-color: ${({ theme }) => theme.commons.colors.gray100};
  border-radius: 3px;
  height: 4px;
  margin: 0;
  position: relative;
  width: 100%;

  &::after {
    background-color: ${({ $backgroundColor }) => $backgroundColor};
    border-radius: 3px;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: ${({ $value }) => $value}%;
  }
`;

export const ProgressBar = (props: ProgressBarProps) => {
  const { value, backgroundColor, ...rest } = props;

  return <StyledProgressBar $value={value} $backgroundColor={backgroundColor} {...rest} />;
};
